export default "__VITE_ASSET__CAEU5w8k__"